import { currecyFormat } from '@/mixins/currency'
import DateTime from '@/components/DateTime'

export default {
  data() {
    return {
      columns: [
        {
          field: 'date',
          title: 'Дата',
          align: 'left',
          sortBy: '',
          key: 'date',
          renderBodyCell: ({ row }, h) => <DateTime date={row.date} />,
        },
        {
          field: 'comment',
          title: 'Сообщение',
          align: 'left',
          sortBy: '',
          key: 'comment',
        },
        {
          field: 'transaction',
          title: 'Сумма, ₽',
          align: 'right',
          sortBy: '',
          key: 'transaction',
          renderBodyCell: ({ row }) => currecyFormat(row.transaction),
        },
      ],
    }
  },
}
